export { PatientVitalsScreen } from './PatientVitalsScreen';
